<!--
 * @Author       : qixiao
 * @Date         : 2023-05-16 10:28:34
 * @LastEditors  : qixiao
 * @LastEditTime : 2023-05-16 14:37:40
 * @FilePath     : \hzs-Houtai\src\views\Agricultural\AgriculturalMonitoring\Weather.vue
 * @Description  : 
 * 
-->
<!--
 * @Descripttion: 
 * @Author: qixiao
 * @Date:2022-5-26 09:46:59
 * @LastEditors: liushumin
 * @LastEditTime: 2023-04-11 18:44:13
-->
<template>
  <div class="apps">
    <div class="hrs"></div>
    <el-main>
      <div class="top-wrap">
        <Bread></Bread>
      </div>
      <div class="main" id="main">
        <div class="soil-box">
          <div class="box-top">
            <span class="h1-top">{{ realData.deviceName }}</span>
            <span class="span-top"
              >设备序列号：<span>{{ realData.deviceCode }}</span>
            </span>
          </div>
          <div class="real-time">
            <span class="h1-real">
              <img
                src="@/assets/agricultural/agrfont/icon_shishishuju.png"
                alt=""
              />
              实时数据</span
            >
            <span class="span-real" v-if="edition == 4"
              >最后数据上报时间：<span>{{ responseTime }}</span>
            </span>
            <span class="span-real" v-else
              >最后数据上报时间：<span>{{ real.sendTime }}</span>
            </span>
          </div>
          <div class="all-price" v-if="edition == 4">
            <div class="div-price">
              <span class="span-price"
                ><img
                  src="@/assets/agricultural/agrfont/icon_kongqiwendu_da.png"
                  alt=""
                /><span class="abs-fs">空气温度</span></span
              >
              <div class="p-price">
                <p v-if="envV4Temperature">
                  <span>{{ envV4Temperature }}</span
                  >℃
                </p>
                <p v-else>
                  <span>-</span>
                </p>
              </div>
            </div>
            <div class="div-price">
              <span class="span-price"
                ><img
                  src="@/assets/agricultural/agrfont/icon_kongqishidu_da.png"
                  alt=""
                /><span class="abs-fs">空气湿度</span></span
              >
              <div class="p-price">
                <p v-if="envV4Humidity">
                  <span>{{ envV4Humidity }}</span
                  >%RH
                </p>
                <p v-else>
                  <span>-</span>
                </p>
              </div>
            </div>
            <div class="div-price">
              <span class="span-price"
                ><img
                  src="@/assets/agricultural/agrfont/icon_fengsu_da.png"
                  alt=""
                /><span class="abs-fs">风速</span></span
              >
              <div class="p-price">
                <p v-if="envV4WindSpeed">
                  <span>{{ envV4WindSpeed }}</span
                  >km/h
                </p>
                <p v-else>
                  <span>-</span>
                </p>
              </div>
            </div>
            <div class="div-price">
              <span class="span-price"
                ><img
                  src="@/assets/agricultural/agrfont/icon_fengxiang_da.png"
                  alt=""
                /><span class="abs-fs">风向</span></span
              >
              <div class="p-price">
                <p v-if="envV4WindDirection">
                  <span style="width: 80px; display: inline-block"
                    >{{ envV4WindDirection }}风</span
                  >
                </p>
                <p v-else>
                  <span>-</span>
                </p>
              </div>
            </div>
            <div class="div-price">
              <span class="span-price2"
                ><img
                  src="@/assets/agricultural/agrfont/icon_guangzhao_da.png"
                  alt=""
                /><span class="abs-fs2">光照强度</span></span
              >
              <div class="p-price">
                <p v-if="envV4Light">
                  <span>{{ envV4Light }}</span
                  >lux
                </p>
                <p v-else>
                  <span>-</span>
                </p>
              </div>
            </div>
            <div class="div-price">
              <span class="span-price"
                ><img
                  src="@/assets/agricultural/agrfont/icon_qiya_da.png"
                  alt=""
                /><span class="abs-fs">大气压力</span></span
              >
              <div class="p-price">
                <p v-if="envV4Pressure">
                  <span>{{ envV4Pressure }}</span
                  >kpa
                </p>
              </div>
            </div>
          </div>
          <div class="all-price" v-else>
            <div class="div-price">
              <span class="span-price"
                ><img
                  src="@/assets/agricultural/agrfont/icon_kongqiwendu_da.png"
                  alt=""
                /><span class="abs-fs">空气温度</span></span
              >
              <div class="p-price">
                <p v-if="real.temperature">
                  <span>{{ real.temperature }}</span
                  >℃
                </p>
                <p v-else>
                  <span>-</span>
                </p>
              </div>
            </div>
            <div class="div-price">
              <span class="span-price"
                ><img
                  src="@/assets/agricultural/agrfont/icon_kongqishidu_da.png"
                  alt=""
                /><span class="abs-fs">空气湿度</span></span
              >
              <div class="p-price">
                <p v-if="real.humidity">
                  <span>{{ real.humidity }}</span
                  >%RH
                </p>
                <p v-else>
                  <span>-</span>
                </p>
              </div>
            </div>
            <div class="div-price">
              <span class="span-price"
                ><img
                  src="@/assets/agricultural/agrfont/icon_fengsu_da.png"
                  alt=""
                /><span class="abs-fs">风速</span></span
              >
              <div class="p-price">
                <p v-if="real.windSpeed">
                  <span>{{ real.windSpeed }}</span
                  >km/h
                </p>
                <p v-else>
                  <span>-</span>
                </p>
              </div>
            </div>
            <div class="div-price">
              <span class="span-price"
                ><img
                  src="@/assets/agricultural/agrfont/icon_fengxiang_da.png"
                  alt=""
                /><span class="abs-fs">风向</span></span
              >
              <div class="p-price">
                <p v-if="envV4WindDirection">
                  <span style="width: 80px; display: inline-block"
                    >{{ fengXiang }}风</span
                  >
                </p>
                <p v-else>
                  <span>-</span>
                </p>
              </div>
            </div>
            <div class="div-price">
              <span class="span-price2"
                ><img
                  src="@/assets/agricultural/agrfont/icon_guangzhao_da.png"
                  alt=""
                /><span class="abs-fs2">光照强度</span></span
              >
              <div class="p-price">
                <p v-if="real.light">
                  <span>{{ real.light }}</span
                  >lux
                </p>
                <p v-else>
                  <span>-</span>
                </p>
              </div>
            </div>
            <div class="div-price">
              <span class="span-price"
                ><img
                  src="@/assets/agricultural/agrfont/icon_qiya_da.png"
                  alt=""
                /><span class="abs-fs">大气压力</span></span
              >
              <div class="p-price">
                <p><span>0kpa</span></p>
              </div>
            </div>
          </div>
          <div class="dialogBox" id="box-center">
            <div class="dialogTitle">
              <img
                src="@/assets/agricultural/agrfont/icon_lishishuju.png"
                alt=""
              />
              历史数据
            </div>
            <div class="queryBox" id="time-center">
              <el-button
                @click="timeClick(1)"
                :style="
                  btnActive === 1
                    ? 'color: #fff;background-color: #018388;border:1px solid #018388;'
                    : ''
                "
                >近7天</el-button
              >
              <el-button
                @click="timeClick(2)"
                :style="
                  btnActive === 2
                    ? 'color: #fff;background-color: #018388;border:1px solid #018388;'
                    : ''
                "
                >近1个月</el-button
              >
              <el-date-picker
                v-model="timeVal"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                @change="dateChange"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
            <div class="echarts_tree">
              <div class="echarts_tree_top">
                <p>
                  <img
                    src="@/assets/agricultural/agrfont/icon_kongqiwendu_da.png"
                    alt=""
                  />
                  <span>空气温度（℃）</span>
                </p>
                <div
                  id="chart1"
                  style="width: 95%; height: 240px"
                  v-show="
                    realAll_Temp.flat.length > 0 || realAll_Temp.vert.length > 0
                  "
                ></div>
                <div
                  class="null-Soil"
                  v-show="
                    realAll_Temp.flat.length === 0 ||
                    realAll_Temp.vert.length === 0
                  "
                >
                  暂无数据
                </div>
              </div>
              <div class="echarts_tree_top">
                <p>
                  <img
                    src="@/assets/agricultural/agrfont/icon_kongqishidu_da.png"
                    alt=""
                  />
                  <span>空气湿度（%RH）</span>
                </p>
                <div
                  id="chart2"
                  style="width: 95%; height: 240px"
                  v-show="
                    realAll_Humidity.flat.length > 0 ||
                    realAll_Humidity.vert.length > 0
                  "
                ></div>
                <div
                  class="null-Soil"
                  v-show="
                    realAll_Humidity.flat.length === 0 ||
                    realAll_Humidity.vert === 0
                  "
                >
                  暂无数据
                </div>
              </div>
              <div class="echarts_tree_top">
                <p>
                  <img
                    src="@/assets/agricultural/agrfont/icon_fengsu_da.png"
                    alt=""
                  />
                  <span>风速（km/h）</span>
                </p>
                <div
                  id="chart3"
                  style="width: 95%; height: 240px"
                  v-show="
                    realAll_WindSpeed.flat.length > 0 ||
                    realAll_WindSpeed.vert.length > 0
                  "
                ></div>
                <div
                  class="null-Soil"
                  v-show="
                    realAll_WindSpeed.flat.length === 0 ||
                    realAll_WindSpeed.vert.length === 0
                  "
                >
                  暂无数据
                </div>
              </div>
              <div class="echarts_tree_top">
                <p>
                  <img
                    src="@/assets/agricultural/agrfont/icon_guangzhao_da.png"
                    alt=""
                  />
                  <span>光照强度（lux）</span>
                </p>
                <div
                  id="chart4"
                  style="width: 95%; height: 240px"
                  v-show="
                    realAll_Light.flat.length > 0 || realAll_Light.vert > 0
                  "
                ></div>
                <div
                  class="null-Soil"
                  v-show="
                    realAll_Light.flat.length === 0 ||
                    realAll_Light.vert.length === 0
                  "
                >
                  暂无数据
                </div>
              </div>
              <!-- <div class="echarts_tree_top">
                <p>
                  <img
                    src="@/assets/agricultural/agrfont/icon_qiya_da.png"
                    alt=""
                  />
                  <span>大气压力（kpa）</span>
                </p>
                <div
                  id="chart5"
                  style="width: 95%; height: 240px"
                  v-show="realAll_Ph.flat || realAll_Ph.vert"
                ></div>
                <div
                  class="null-Soil"
                  v-show="!realAll_Ph.flat || !realAll_Ph.vert"
                >
                  暂无数据
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </el-main>
  </div>
</template>

<script>
export default {
  name: "AgrMonitoringWeather",
  data() {
    return {
      deviceTypeId: "",
      btnActive: 1,
      timeVal: "",
      real: {},
      fengXiang: "",
      realAll_Temp: {
        //空气温度
        flat: false,
        vert: false,
      },
      realAll_Humidity: {
        //空气湿度
        flat: false,
        vert: false,
      },
      realAll_WindSpeed: {
        //风速
        flat: false,
        vert: false,
      },
      realAll_Light: {
        //光照强度
        flat: false,
        vert: false,
      },
      realAll_Ph: {
        //大气压力
        flat: false,
        vert: false,
      },
      realData: {
        deviceCode: "-",
        deviceName: "-",
      },
      edition: "",
      responseTime: "",
      envV4Temperature: "",
      envV4Humidity: "",
      envV4WindDirection: "",
      envV4WindSpeed: "",
      envV4Pressure: "",
      envV4Light: "",
    };
  },
  mounted() {
    this.getRealWeatherDateAll();
  },
  created() {
    this.getRealWeatherDate();
  },
  methods: {
    // 气象实时数据
    getRealWeatherDate() {
      let farmAllData = JSON.parse(sessionStorage.getItem("farmAllData"));
      this.edition = farmAllData.edition;
      this.realData = {
        deviceCode: farmAllData.deviceCode,
        deviceName: farmAllData.deviceName,
      };
      let obj = { sensorNum: this.realData.deviceCode };
      if (this.edition != 4) {
        this.$http.agrModel.getWeather(obj).then((res) => {
          if (res.status === "1") {
            if (res.data) {
              this.real = res.data;
              if (res.data.windDirection && res.data.windDirection != null) {
                if (res.data.windDirection == "W") {
                  this.fengXiang = "西";
                } else if (res.data.windDirection == "N") {
                  this.fengXiang = "北";
                } else if (res.data.windDirection == "E") {
                  this.fengXiang = "东";
                } else if (res.data.windDirection == "ES") {
                  this.fengXiang = "东南";
                } else if (res.data.windDirection == "WS") {
                  this.fengXiang = "西南";
                } else if (res.data.windDirection == "WN") {
                  this.fengXiang = "西北";
                } else if (res.data.windDirection == "S") {
                  this.fengXiang = "南";
                } else if (res.data.windDirection == "EN") {
                  this.fengXiang = "东北";
                }
              }
            }
          } else {
            this.$message({
              message: res.errMsg,
              type: "error",
              customClass: "customClass",
            });
          }
        });
      } else {
        this.$http.nqMonitor
          .monitorGroupV4({ imei: this.realData.deviceCode })
          .then((res) => {
            if (res.status == 1) {
              this.responseTime = res.data.result[0].sendTime;
              if (res.data.result && res.data.result.length > 0) {
                let envV4DataList = res.data.result;
                var that = this;
                envV4DataList.forEach((val) => {
                  // A0空气温度
                  if (val.sensorType && val.sensorType == "A0") {
                    that.envV4Temperature = val.sensorData;
                  }
                  // A1空气湿度
                  if (val.sensorType && val.sensorType == "A1") {
                    that.envV4Humidity = val.sensorData;
                  }
                  // A5大气压力
                  if (val.sensorType && val.sensorType == "A5") {
                    that.envV4Pressure = val.sensorData;
                  }
                  // A3风速
                  if (val.sensorType && val.sensorType == "A3") {
                    that.envV4WindSpeed = val.sensorData;
                  }
                  // A4风向
                  if (val.sensorType && val.sensorType == "A4") {
                    if (val.sensorData && val.sensorData != null) {
                      if (val.sensorData == "W") {
                        that.envV4WindDirection = "西";
                      } else if (val.sensorData == "N") {
                        that.envV4WindDirection = "北";
                      } else if (val.sensorData == "E") {
                        that.envV4WindDirection = "东";
                      } else if (val.sensorData == "ES") {
                        that.envV4WindDirection = "东南";
                      } else if (val.sensorData == "WS") {
                        that.envV4WindDirection = "西南";
                      } else if (val.sensorData == "WN") {
                        that.envV4WindDirection = "西北";
                      } else if (val.sensorData == "S") {
                        that.envV4WindDirection = "南";
                      } else if (val.sensorData == "EN") {
                        that.envV4WindDirection = "东北";
                      }
                    }
                  }
                  // A2光照强度
                  if (val.sensorType && val.sensorType == "A2") {
                    that.envV4Light = val.sensorData;
                  }
                });
                this.deviceStatus = "设备正常";
              } else {
                this.envV4Temperature = "";
                this.envV4Humidity = "";
                this.envV4WindDirection = "";
                this.envV4WindSpeed = "";
                this.envV4Pressure = "";
                this.envV4Light = "";
                this.deviceStatus = null;
              }
            } else {
              this.deviceStatus = null;
            }
          });
      }
    },
    // 土壤历史数据
    getRealWeatherDateAll(data) {
      let time = "";
      let timeArr = [];
      let obj = {};
      let currentDay = false;
      if (this.btnActive === 1) {
        time = "w";
        obj = {
          sensorNum: this.realData.deviceCode, //传感器号
          type: time, //类型；w 最近七天；m 最近30天
        };
      } else if (this.btnActive === 2) {
        time = "m";
        obj = {
          sensorNum: this.realData.deviceCode, //传感器号
          type: time, //类型；w 最近七天；m 最近30天
        };
      } else {
        timeArr = data;
        if (this.timeVal && this.timeVal[0] != "" && this.timeVal[1] != "") {
          if (this.timeVal[0] == this.timeVal[1]) {
            currentDay = true;
          }
        }
        obj = {
          sensorNum: this.realData.deviceCode, //传感器号
          startTime: timeArr[0],
          endTime: timeArr[1],
        }; //类型；w 最近七天；m 最近30天
      }
      if (this.edition != 4) {
        this.$http.agrModel.getWeatherAll(obj).then((res) => {
          // console.log(res);
          if (res.status === "1") {
            if (res.data.length > 0) {
              this.realAll_Temp.flat = [];
              this.realAll_Humidity.flat = [];
              this.realAll_WindSpeed.flat = [];
              this.realAll_Light.flat = [];
              this.realAll_Ph.flat = [];
              this.realAll_Temp.vert = [];
              this.realAll_Humidity.vert = [];
              this.realAll_WindSpeed.vert = [];
              this.realAll_Light.vert = [];
              this.realAll_Ph.vert = [];

              res.data.forEach((item, index) => {
                this.realAll_Temp.flat.push(item.sendTime.slice(0, 10));
                this.realAll_Humidity.flat.push(item.sendTime.slice(0, 10));
                this.realAll_WindSpeed.flat.push(item.sendTime.slice(0, 10));
                this.realAll_Light.flat.push(item.sendTime.slice(0, 10));
                this.realAll_Ph.flat.push(item.sendTime.slice(0, 10));
                this.realAll_Temp.vert.push(item.temperature);
                this.realAll_Humidity.vert.push(item.humidity);
                this.realAll_WindSpeed.vert.push(item.windSpeed);
                this.realAll_Light.vert.push(item.light);
                this.realAll_Ph.vert.push(item.windDirection);
              });

              this.getEchartData1();
              this.getEchartData2();
              this.getEchartData3();
              this.getEchartData4();
              this.getEchartData5();
            } else {
              this.realAll_Temp.flat = [];
              this.realAll_Humidity.flat = [];
              this.realAll_WindSpeed.flat = [];
              this.realAll_Light.flat = [];
              this.realAll_Ph.flat = [];
              this.realAll_Temp.vert = [];
              this.realAll_Humidity.vert = [];
              this.realAll_WindSpeed.vert = [];
              this.realAll_Light.vert = [];
              this.realAll_Ph.vert = [];
            }
          } else {
            this.$message({
              message: res.errMsg,
              type: "error",
              customClass: "customClass",
            });
          }
        });
      } else {
        this.$http.nqMonitor.monitorHisGroupV4(obj).then((res) => {
          console.log(res);
          if (res.data.code == 1) {
            let echartsDatas = res.data.result;
            if (echartsDatas.length > 0) {
              var that = this;
              echartsDatas.forEach((item) => {
                if (item.sensorType && item.sensorType == "A0") {
                  let soilSaltMapList = item.list;
                  if (soilSaltMapList.length > 0) {
                    that.realAll_Temp.flat = [];
                    that.realAll_Temp.vert = [];
                    soilSaltMapList.forEach((its) => {
                      that.realAll_Temp.flat.push(its.sendTime);
                      if (currentDay == true) {
                        that.realAll_Temp.vert.push(its.sensorData);
                      } else {
                        that.realAll_Temp.vert.push(its.avgVal);
                      }
                    });
                  }
                }
                if (item.sensorType && item.sensorType == "A1") {
                  let soilConductivityDataMapList = item.list;
                  if (soilConductivityDataMapList.length > 0) {
                    that.realAll_Humidity.flat = [];
                    that.realAll_Humidity.vert = [];
                    soilConductivityDataMapList.forEach((its) => {
                      that.realAll_Humidity.flat.push(its.sendTime);
                      if (currentDay == true) {
                        that.realAll_Humidity.vert.push(its.sensorData);
                      } else {
                        that.realAll_Humidity.vert.push(its.avgVal);
                      }
                    });
                  }
                }
                if (item.sensorType && item.sensorType == "A3") {
                  let soilSaltMapList = item.list;
                  if (soilSaltMapList.length > 0) {
                    that.realAll_WindSpeed.flat = [];
                    that.realAll_WindSpeed.vert = [];
                    soilSaltMapList.forEach((its) => {
                      that.realAll_WindSpeed.flat.push(its.sendTime);
                      if (currentDay == true) {
                        that.realAll_WindSpeed.vert.push(its.sensorData);
                      } else {
                        that.realAll_WindSpeed.vert.push(its.avgVal);
                      }
                    });
                  }
                }
                if (item.sensorType && item.sensorType == "A2") {
                  let soilConductivityDataMapList = item.list;
                  if (soilConductivityDataMapList.length > 0) {
                    that.realAll_Light.flat = [];
                    that.realAll_Light.vert = [];
                    soilConductivityDataMapList.forEach((its) => {
                      that.realAll_Light.flat.push(its.sendTime);
                      if (currentDay == true) {
                        that.realAll_Light.vert.push(its.sensorData);
                      } else {
                        that.realAll_Light.vert.push(its.avgVal);
                      }
                    });
                  }
                }
              });
            } else {
              this.realAll_Temp.flat = [];
              this.realAll_Temp.vert = [];
              this.realAll_Humidity.flat = [];
              this.realAll_Humidity.vert = [];
              this.realAll_Light.flat = [];
              this.realAll_Light.vert = [];
              this.realAll_WindSpeed.flat = [];
              this.realAll_WindSpeed.vert = [];
            }
            this.getEchartData1();
            this.getEchartData2();
            this.getEchartData3();
            this.getEchartData4();
            this.getEchartData5();
          } else {
            this.$message({
              message: res.errMsg,
              type: "error",
              customClass: "customClass",
            });
          }
        });
      }
    },
    // getEchartData函数都为 图表
    getEchartData1() {
      this.$nextTick(() => {
        const chart1 = document.getElementById("chart1");
        var _that = this;
        if (chart1) {
          const myChart = this.$echarts.init(chart1);
          const option = {
            tooltip: {
              trigger: "axis",

              formatter: (params) => {
                let template = "";
                params.forEach((item, index) => {
                  if (index == 0) {
                    template = item.axisValue + "<br>";
                  }
                  if (item.seriesType === "line") {
                    item.value += "";
                  }
                  template =
                    template +
                    item.marker +
                    "空气温度（℃）" +
                    " : " +
                    item.value +
                    "<br>";
                });
                return template;
              },
            },

            grid: {
              left: "3%",
              right: "6%",
              bottom: "14%",
              top: "6%",
              containLabel: true,
            },

            xAxis: {
              type: "category",
              boundaryGap: false,
              data: _that.realAll_Temp.flat,
            },
            yAxis: {
              type: "value",
            },
            series: [
              {
                type: "line",
                stack: "Total",
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: "#cff7f9",
                    lineStyle: {
                      color: "#3FE1E7",
                    },
                  },
                },
                data: _that.realAll_Temp.vert,
              },
            ],
          };
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
        this.$on("hook:destroyed", () => {
          window.removeEventListener("resize", function () {
            myChart.resize();
          });
        });
      });
    },
    getEchartData2() {
      this.$nextTick(() => {
        const chart2 = document.getElementById("chart2");
        if (chart2) {
          const myChart = this.$echarts.init(chart2);
          const option = {
            tooltip: {
              trigger: "axis",
              formatter: (params) => {
                let template = "";
                params.forEach((item, index) => {
                  if (index == 0) {
                    template = item.axisValue + "<br>";
                  }
                  if (item.seriesType === "line") {
                    item.value += "";
                  }
                  template =
                    template +
                    item.marker +
                    "空气湿度（%RH）" +
                    " : " +
                    item.value +
                    "<br>";
                });
                return template;
              },
            },

            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#cff7f9", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#cff7f9", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            grid: {
              left: "3%",
              right: "6%",
              bottom: "14%",
              top: "6%",
              containLabel: true,
            },

            xAxis: {
              type: "category",
              boundaryGap: false,
              data: this.realAll_Humidity.flat,
            },
            yAxis: {
              type: "value",
            },
            series: [
              {
                type: "line",
                stack: "Total",
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: "#cff7f9",
                    lineStyle: {
                      color: "#3FE1E7",
                    },
                  },
                },
                data: this.realAll_Humidity.vert,
              },
            ],
          };
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
        this.$on("hook:destroyed", () => {
          window.removeEventListener("resize", function () {
            myChart.resize();
          });
        });
      });
    },
    getEchartData3() {
      this.$nextTick(() => {
        const chart3 = document.getElementById("chart3");
        if (chart3) {
          const myChart = this.$echarts.init(chart3);
          const option = {
            tooltip: {
              trigger: "axis",
              formatter: (params) => {
                let template = "";
                params.forEach((item, index) => {
                  if (index == 0) {
                    template = item.axisValue + "<br>";
                  }
                  if (item.seriesType === "line") {
                    item.value += "";
                  }
                  template =
                    template +
                    item.marker +
                    "风速（km/h）" +
                    " : " +
                    item.value +
                    "<br>";
                });
                return template;
              },
            },

            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#cff7f9", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#cff7f9", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            grid: {
              left: "3%",
              right: "6%",
              bottom: "14%",
              top: "6%",
              containLabel: true,
            },

            xAxis: {
              type: "category",
              boundaryGap: false,
              data: this.realAll_WindSpeed.flat,
            },
            yAxis: {
              type: "value",
            },
            series: [
              {
                type: "line",
                stack: "Total",
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: "#cff7f9",
                    lineStyle: {
                      color: "#3FE1E7",
                    },
                  },
                },
                data: this.realAll_WindSpeed.vert,
              },
            ],
          };
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
        this.$on("hook:destroyed", () => {
          window.removeEventListener("resize", function () {
            myChart.resize();
          });
        });
      });
    },
    getEchartData4() {
      this.$nextTick(() => {
        const chart4 = document.getElementById("chart4");
        if (chart4) {
          const myChart = this.$echarts.init(chart4);
          const option = {
            tooltip: {
              trigger: "axis",
              formatter: (params) => {
                let template = "";
                params.forEach((item, index) => {
                  if (index == 0) {
                    template = item.axisValue + "<br>";
                  }
                  if (item.seriesType === "line") {
                    item.value += "";
                  }
                  template =
                    template +
                    item.marker +
                    "光照强度（lux）" +
                    " : " +
                    item.value +
                    "<br>";
                });
                return template;
              },
            },

            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#cff7f9", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#cff7f9", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            grid: {
              left: "3%",
              right: "6%",
              bottom: "14%",
              top: "6%",
              containLabel: true,
            },

            xAxis: {
              type: "category",
              boundaryGap: false,
              data: this.realAll_Light.flat,
            },
            yAxis: {
              type: "value",
            },
            series: [
              {
                type: "line",
                stack: "Total",
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: "#cff7f9",
                    lineStyle: {
                      color: "#3FE1E7",
                    },
                  },
                },
                data: this.realAll_Light.vert,
              },
            ],
          };
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
        this.$on("hook:destroyed", () => {
          window.removeEventListener("resize", function () {
            myChart.resize();
          });
        });
      });
    },
    getEchartData5() {
      this.$nextTick(() => {
        const chart5 = document.getElementById("chart5");
        if (chart5) {
          const myChart = this.$echarts.init(chart5);
          const option = {
            tooltip: {
              trigger: "axis",
              formatter: (params) => {
                let template = "";
                params.forEach((item, index) => {
                  if (index == 0) {
                    template = item.axisValue + "<br>";
                  }
                  if (item.seriesType === "line") {
                    item.value += "";
                  }
                  template =
                    template +
                    item.marker +
                    "大气压力（kpa）" +
                    " : " +
                    item.value +
                    "<br>";
                });
                return template;
              },
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#cff7f9", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#cff7f9", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#cff7f9", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#cff7f9", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            grid: {
              left: "3%",
              right: "6%",
              bottom: "14%",
              top: "6%",
              containLabel: true,
            },

            xAxis: {
              type: "category",
              boundaryGap: false,
              data: this.realAll_Ph.flat,
            },
            yAxis: {
              type: "value",
            },
            series: [
              {
                type: "line",
                stack: "Total",
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: "#cff7f9",
                    lineStyle: {
                      color: "#3FE1E7",
                    },
                  },
                },
                data: this.realAll_Ph.vert,
              },
            ],
          };
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
        this.$on("hook:destroyed", () => {
          window.removeEventListener("resize", function () {
            myChart.resize();
          });
        });
      });
    },
    timeClick(num) {
      this.timeVal = "";

      this.btnActive = num;
      if (num === 1) {
        this.getRealWeatherDateAll("w");
      } else if (num === 2) {
        this.getRealWeatherDateAll("m");
      }
    },
    dateChange(val) {
      if (val && val[0]) {
        this.btnActive = 3;
      }
      this.getRealWeatherDateAll(val);
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.apps {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  margin: 0;
  padding: 0;

  .soil-box {
    width: 100%;
    height: 100%;
    .box-top {
      height: 3vh;
      position: relative;
      .h1-top {
        font-size: 22px;
        color: #333;
        margin-right: 4vh;
        font-weight: 700;
      }
      .span-top {
        font-size: 16px;
        margin-right: 4vh;
        color: #888;
      }
      .span-go {
        position: absolute;
        right: 5vh;
        top: 1vh;
        font-size: 1.6vh;
        text-align: right;
        cursor: pointer;
        color: #018388;

        i {
          font-size: 1.6vh;
          margin-right: 0.5vh;
        }
      }
    }
    .real-time {
      height: 3vh;
      margin-top: 30px;
      color: #018388;
      // overflow-x: auto;
      .h1-real {
        font-size: 18px;
        margin-right: 2vh;
        font-weight: 700;
      }
      .span-real {
        font-size: 16px;
        margin-right: 4vh;
        margin-left: 1.2vh;
      }
      img {
        height: 18px;
        vertical-align: bottom;
        margin-bottom: 2px;
      }
    }
    .all-price {
      margin-top: 2vh;
      margin-bottom: 1vh;
      box-sizing: border-box;
      height: 110px;
      width: 100%;
      font-size: 16px;
      font-weight: 600;
      display: flex;
      justify-content: space-between;
      .p-price {
        margin-left: 3vh;
        display: inline-block;
        position: relative;
        p {
          position: absolute;
          top: -5vh;
          font-weight: 400;
          color: #444;
          font-size: 2.1vh;
        }
      }
      .div-price {
        width: 15.75%;
        height: 100%;
        box-sizing: border-box;
        padding: 20px 0;
        text-align: center;
        margin-right: 10px;
        display: inline-block;
        background-color: #f4faf9;
        .span-price {
          display: inline-block;
          height: 100%;
          margin-left: -4vw;
          .abs-fs {
            font-weight: 600;
            font-size: 16px;
            color: #018388;
          }
          img {
            display: block;
            height: 40px;
            text-align: center;
            margin: 0 auto;
            margin-bottom: 1.5vh;
          }
        }
        .span-price2 {
          display: inline-block;
          height: 100%;
          margin-left: -10vh;
          .abs-fs2 {
            font-weight: 600;
            font-size: 16px;
            color: #018388;
          }
          img {
            display: block;
            height: 40px;
            text-align: center;
            margin: 0 auto;
            margin-bottom: 1.5vh;
          }
        }
      }
    }
  }
  #box-center {
    margin-top: 2vh;
    height: 100%;
    .dialogTitle {
      font-size: 18px;
      margin-right: 2vh;
      font-weight: 700;
      margin-bottom: 2vh;
      color: #018388;

      img {
        height: 18px;
        vertical-align: bottom;
        margin-bottom: 2px;
      }
    }
    .time-center {
      width: 100%;
    }
    ::v-deep .el-date-editor.el-input__inner {
      width: 30%;
      margin-left: 2vh;
    }
    ::v-deep .el-input__inner {
      height: 37px;
    }
    .echarts_tree {
      margin-top: 2vh;
      .echarts_tree_top {
        width: 50%;
        float: left;
        .null-Soil {
          text-align: center;
          height: 240px;
          line-height: 240px;
        }
        p {
          margin-bottom: 10px;
          img {
            height: 18px;
            vertical-align: middle;
          }
          span {
            font-size: 16px;
            margin-left: 1vh;
            vertical-align: middle;
          }
        }
      }
    }
  }
  .hrs {
    position: absolute;
    top: 120px;
    left: 2vh;
    width: 98%;
    height: 1px;
    background-color: #efefef;
  }
}
</style>
